import { render, staticRenderFns } from "./GenericImage.vue?vue&type=template&id=769bec40&scoped=true"
import script from "./GenericImage.vue?vue&type=script&lang=js"
export * from "./GenericImage.vue?vue&type=script&lang=js"
import style0 from "./GenericImage.vue?vue&type=style&index=0&id=769bec40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769bec40",
  null
  
)

export default component.exports